import { useMemo } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { IRouteConfig } from '../interfaces/routeConfig';
import routes from '../routes/routes';

export const useCurrentRoute = () => {
  const location = useLocation();
  const matchedRoutes = useMemo(() => {
    const findRouteStack = (items: IRouteConfig[]): IRouteConfig[] => {
      const route =
        items.find((item) => {
          if (item.path === '*') return false;
          const hasChildren = !!item.routes?.length;
          const path =
            hasChildren && !item.path.endsWith('*')
              ? `${item.path.replace(/\/$/, '')}/*`
              : item.path;
          return matchPath(
            { path, end: !hasChildren && !path.endsWith('*') },
            location.pathname,
          );
        }) ?? items.find((item) => item.path === '*');

      if (!route) return [];
      return [route, ...(route.routes ? findRouteStack(route.routes) : [])];
    };

    return findRouteStack(routes);
  }, [location.pathname]);
  const leafRoute = matchedRoutes.at(-1);

  return {
    leafRoute,
    matchedRoutes,
  };
};
